export default {
    getPhone(state) {
        return state.phone;
    },
    getEmail(state) {
        return state.email;
    },
    getGithub(state) {
        return state.github;
    },
    getGmail(state) {
        return state.gmail;
    },
    getLinkedin(state) {
        return state.linkedin;
    },
    getTwitter(state) {
        return state.twitter;
    }
}